export const STATE_OF_CHARGE_REQUEST_ATTRIBUTES = [
    'driver_ids',
    'interval_desc',
    'result_from',
    'result_to',
    'electric_max_state_of_charge',
    'vehicle_ids',
];
